import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/css/scrollbar';
import { Navigation, Scrollbar, Autoplay } from 'swiper/modules';

import blueHeartIcon from '../../assets/icons/blueHeartIcon.svg';
import yellowStar from '../../assets/icons/yellowStar.svg';

const slides = [
  {
    id: 1,
    text: 'Это просто рай! После рабочего дня — залезаю в ванну с гидромассажем, и все заботы будто исчезают. Тепло, струйки приятно массируют, кожа потом такая мягкая. Настоящее наслаждение и забота о себе.',
    author: 'Мария',
  },
  {
    id: 2,
    text: 'Решил попробовать гидромассаж по совету знакомого — и не пожалел. После тренировок — самое то. Мышцы расслабляются, уходит усталость. Работает чётко, без сбоев. Отличная штука, особенно если ценишь восстановление и комфорт.',
    author: 'Евгений',
  },
  {
    id: 3,
    text: 'Гидромассаж приятно удивил. Хорошее давление струй, чувствуется эффект уже после первых процедур. Спина, плечи — всё расслабляется. Подходит как для релакса, так и в профилактических целях. В целом — отличное дополнение к уходу за телом.',
    author: 'Аня',
  },
]

function Reviews() {
  return ( 
    <div className="reviews" id='reviews'>
      <div className='reviews__header'>
        <span className='reviews__header-text'>ОТЗЫВЫ НАШИХ
          <span className='reviews__header-text-blue'>КЛИЕНТОВ</span>
        </span>
        <img className='reviews__header-img' src={blueHeartIcon} alt="" />
      </div>
      <Swiper
        modules={[Navigation, Autoplay, Scrollbar]}
        spaceBetween={20}
        scrollbar={{ draggable: true }}
        navigation={true}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        centeredSlides={true}
        slidesPerView={3}
        className="reviews__swiper swiper"
      >
        {slides.map(item => (
          <SwiperSlide key={item.id} className='swiper__slide'>
            <div className='swiper__slide-wrapper'>
              <p className='swiper__slide-text'>{item.text}</p>
              <div className='swiper__slide-bottom'>
                <p className='swiper__slide-author'>{item.author}</p>
                <div className='swiper__slide-stars'>
                  <img className='swiper__slide-star' src={yellowStar} alt="звезда" />
                  <img className='swiper__slide-star' src={yellowStar} alt="звезда" />
                  <img className='swiper__slide-star' src={yellowStar} alt="звезда" />
                  <img className='swiper__slide-star' src={yellowStar} alt="звезда" />
                  <img className='swiper__slide-star' src={yellowStar} alt="звезда" />
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
   );
}

export default Reviews;